/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import Modal from './Modal/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaIconClose from 'DesignSystem/Svgs/TysiaIconClose/index'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/TreatmentPlanStatus/Content",
  showCancelInternalFinancialAction
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsBlue200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.200'
        })
let dtColorsBlue900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.900'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let treatmentCardTxsTreatmentPlanActionValueData = fromData.useDataValue({ viewPath,
context: 'treatment_card',
path: 'txs.treatment_plan_action',
})
let constantData = 'view_case_closer_request'
let aggregateData = fromAggregate.equals(treatmentCardTxsTreatmentPlanActionValueData, constantData)
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 offsetMainAxis={6}
 hoverLeaveDelay={100}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaTag
{...childProps}
  viewPath={`${viewPath}/TysiaTag`}
 cursor="normal"
 backgroundColor={dtColorsBlue200}
 color={dtColorsBlue900}
 marginLeft={dtSpaceXs}
 marginTop={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={!showCancelInternalFinancialAction}>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
 fill={dtColorsBlue900}
>
{childProps => (
<TysiaIconWarning
{...childProps}
  viewPath={`${viewPath}/TysiaIconWarning`}
 marginLeft={0}
 marginRight={dtSpaceXxs}
 width={16}
 height={16}
/>
)}
</TysiaTagIcon>
</fromFlow.When>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text={aggregateData ? "Case Closer" : "Need Action"}
 data="treatment_card.txs.treatment_plan_action"
 data="'view_case_closer_request'"
 aggregate="/Data/aggregate.js equals"
/>
</React.Fragment>
)}
</TysiaTag>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
<fromFlow.When is={showCancelInternalFinancialAction}>
<button
  data-testid="Content1.Vertical"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Modal/Content'))}
 {...isHoveredBind}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconClose
  viewPath={`${viewPath}/TysiaIconClose`}
 fill={dtColorsBlue900}
 marginRight={0}
 width={16}
 height={16}
/>
</button>
</fromFlow.When>
<Modal
  viewPath={`${viewPath}/Modal`}
/>
{children}
</React.Fragment>)
}